import { Question } from '../../types/survey.types';

// Phase 6 - US4: Numeric Question Component (T115)

interface NumericQuestionProps {
  question: Question;
  value?: number;
  onChange: (value: number) => void;
}

const NumericQuestion = ({ question, value, onChange }: NumericQuestionProps) => {
  const options = question.options as { min?: number; max?: number };
  const min = options?.min;
  const max = options?.max;

  // For NUMBER type, show a simple input
  return (
    <input
      type="number"
      value={value ?? ''}
      onChange={(e) => onChange(Number(e.target.value))}
      min={min}
      max={max}
      placeholder="Digite um número..."
      className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    />
  );
};

export default NumericQuestion;
